import { createFileRoute } from '@tanstack/react-router';
import { BenefitCatalogDetailPage } from './BenefitCatalogDetailPage';

export const Route = createFileRoute('/_protected/admin/internal-tools/benefit-catalog/$entryId/')({
  component: BenefitCatalogDetailPage,
});
